import { client } from '@/common-utils/libraries/axios/axios';
import PAYLUDD_SUBSCRIPTIONS from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationTriggerEmergencyRemoteCollection = (onSuccess, onError) => {
    return {
        mutationFn: ({ posTerminalId, contractId, transactionsList }) => {
            return client.post((replaceParameters(PAYLUDD_SUBSCRIPTIONS.EMERGENCY_REMOTE_COLLECTION_TRIGGER.url, { uuid: posTerminalId })),
                { transactionsList: transactionsList, VADContractUuid: contractId });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationTriggerEmergencyRemoteCollection;